<div *ngIf="initialized && show">
    <div class="menu-panel">
        <!-- <div style="border-bottom: 1px solid #ccc;margin-bottom: 1px;">
        </div> -->

        <div class="menu-body">
            <div class="main-menu" *ngIf="mode === 'menu-mode'">
                <button type="button" class="menu-btn btn-w100" (click)="selectAll()">
                    <i class="fas fa-mouse-pointer"></i> 전체선택
                </button>
                <button type="button" class="menu-btn btn-w100" (click)="autoSizeColumns()">
                    <i class="fas fa-arrows-alt-h"></i> 컬럼 자동맞춤
                </button>
                <button type="button" class="menu-btn btn-w100" (click)="showColumnPicker()">
                    <i class="fas fa-columns"></i> 컬럼 선택
                </button>
                <button type="button" class="menu-btn btn-w100" (click)="saveFlexGridLayout()"
                    *ngIf="flexGridCtrl.canUserStateConfig">
                    <i class="far fa-window-restore"></i> 컬럼 레이아웃 저장
                </button>
                <button type="button" class="menu-btn btn-w100" (click)="clearFlexGridLayout()">
                    <i class="fas fa-redo-alt"></i> 컬럼 레이아웃 초기화
                </button>
                <button type="button" class="menu-btn btn-w100" (click)="showFreezBar()"
                    *ngIf="!this.flexGridCtrl.freezBar.isShow">
                    <i class="fas fa-thumbtack"></i> 틀 고정 변경
                </button>
                <button type="button" class="menu-btn btn-w100" (click)="hideFreezBar()"
                    *ngIf="this.flexGridCtrl.freezBar.isShow">
                    <i class="fas fa-thumbtack"></i> 틀 고정 완료
                </button>
                <button type="button" class="menu-btn btn-w100" (click)="saveToExcel()" *ngIf="canExcelDownload">
                    <i class="fas fa-file-excel"></i> 엑셀저장
                </button>
            </div>
            <div *ngIf="mode === 'column-picker'">
                <wj-list-box #columnsList id="columnsList" class="column-picker" [itemsSource]="flexGridCtrl.flexGrid.columns"
                    [checkedMemberPath]="'visible'" [displayMemberPath]="'header'"></wj-list-box>
            </div>
        </div>

        <div class="menu-footer">
            <!-- <button *ngIf="mode === 'column-picker'" type="button" class="menu-btn btn-w100 close-btn"
                style="color: #0059ff;" (click)="toggleAllColumns()"><i class="fas fa-times"></i>전체</button> -->
            <button type="button" class="menu-btn btn-w100 close-btn" style="color: #666;" (click)="toggle()"><i
                    class="fas fa-times"></i> 닫기</button>
        </div>


    </div>

</div>